"use client";
import { useState } from "react";
import { motion } from "framer-motion";
import EnglishLab from "./EnglishLab";
import CareerLab from "./CareerLab";
import AppitudeLab from "./AppitudeLab";

function Digilab() {
  const [activeTab, setActiveTab] = useState("englishlab");

  const tabs = [
    { id: "englishlab", label: "English Lab" },
    { id: "careerlab", label: "Career Lab" },
    { id: "aptitudelab", label: "Aptitude Lab" },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "englishlab":
        return <EnglishLab />;
      case "careerlab":
        return <CareerLab />;
      case "aptitudelab":
        return <AppitudeLab />;
      default:
        return <EnglishLab />;
    }
  };

  return (
    <div className="mt-10">
      {/* Tab Navigation */}
      <div
        className="d-flex justify-content-center border-bottom mb-3 overflow-auto"
        style={{ whiteSpace: "nowrap" }}
      >
        <div className="d-flex justify-content-center w-100">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`btn bg-transparent position-relative px-2 px-sm-3 px-md-4 px-lg-5 py-2 py-sm-3 fs-5 fs-sm-4 fs-md-3 fw-bold flex-grow-0 flex-shrink-0 
                ${
                  activeTab === tab.id
                    ? "text-primary border border-primary rounded-top"
                    : "text-secondary border-0"
                }`}
              style={{
                borderBottom:
                  activeTab === tab.id ? "4px solid #0d6efd" : "none",
                minWidth: "fit-content",
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <motion.div
        key={activeTab}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="bg-white rounded shadow p-3 p-sm-4"
      >
        {renderContent()}
      </motion.div>
    </div>
  );
}

export default Digilab;
